// src/constants.js
//
// Mirrors tracker/models.py's STATUS_CHOICES / FIELDWORK_STATUS_CHOICES on
// the backend. Kept in one place so every stage card uses the same labels
// instead of each page hand-rolling its own copy.

export const STATUS_CHOICES = [
  ["pending", "Pending"],
  ["in_progress", "In progress"],
  ["submitted", "Submitted"],
  ["approved", "Approved"],
];

export const FIELDWORK_STATUS_CHOICES = [
  ["pending", "Pending"],
  ["in_progress", "In progress"],
  ["completed", "Completed"],
];

export function statusLabel(choices, value) {
  const found = choices.find(([v]) => v === value);
  return found ? found[1] : value;
}

// Union of every status value used anywhere (STATUS_CHOICES plus
// Fieldwork's "completed", which isn't in STATUS_CHOICES). Used by the
// dashboards, which see status values from every stage table at once and
// don't know ahead of time which set a given value came from.
export const ALL_STATUS_CHOICES = [
  ...STATUS_CHOICES,
  ...FIELDWORK_STATUS_CHOICES.filter(
    ([value]) => !STATUS_CHOICES.some(([v]) => v === value)
  ),
];

export function anyStatusLabel(value) {
  return statusLabel(ALL_STATUS_CHOICES, value);
}

export const STAGE_TITLES = {
  permit: "Permit",
  fieldwork: "Fieldwork",
  site_data: "Site data",
  final_report: "Final report",
  digital_data: "Digital data",
  artifact_submission: "Artifacts",
};
